<div class="header">
  <div class="ball-container">
    <img
      #clickableImage
      (click)="goToScoreTable(clickableImage)"
      class="clickable-image"
      src="assets/img/AtosEvidenBall 3.png"
      alt="AtosEvidenBall"
      title="Go to Score Table"
    />
  </div>
  <p class="header-title" (click)="goToScoreTable(clickableImage)">
      Kick it like <span style="color: #0596FF;">Atos</span> & <span style="color: #FF6D43;">Eviden</span>
  </p>
  <div class="header-menu-container">
    <app-header-menu></app-header-menu>
  </div>
</div>
